import React, { Component } from 'react';
import { Card, Icon, message, Modal, Row, Tree } from 'antd';
import { queryDeleteProjDir, queryProjDirInfo, querySaveProjDir } from '@api/task';
import ModalDirAdd from './ModalDirAdd';
import './TreeDirectory.less';

const { TreeNode } = Tree;
const { confirm } = Modal;

class TreeDirectory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      expandedKeys: [],
      selectedKeys: [],
      isAddType: true,
      directoryInfo: null,
    };
  }

  componentDidMount() {
    const list = this.props.data;
    const { directoryUuid } = this.props;
    let expandedKeys = [];
    expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
    this.setState({ list, selectedKeys: [directoryUuid], expandedKeys });
  }

  componentWillReceiveProps(nextProps) {
    const list = nextProps.data;
    const { directoryUuid } = nextProps;
    let { expandedKeys } = this.state;
    if (list !== this.props.data) {
      expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
      expandedKeys = expandedKeys.filter((currentValue, index, arr) => {
        return arr.indexOf(currentValue) === index && currentValue;
      });
      this.setState({
        list,
        directoryInfo: null,
        expandedKeys,
      });
    }

    if (directoryUuid !== this.props.directoryUuid) {
      this.setState({
        selectedKeys: [directoryUuid],
      });
    }
  }

  // 找到该目录的所有父级目录（及以上）
  getParentKey = (key, tree, grandKeys) => {
    let parentKey;
    const grandKey = grandKeys || [];
    tree.map(item => {
      if (item.children) {
        if (item.children.some(item1 => item1.uuid === key)) {
          grandKey.push(item.uuid);
          parentKey = grandKey;
        } else if (this.getParentKey(key, item.children)) {
          grandKey.push(item.uuid);
          parentKey = this.getParentKey(key, item.children, grandKey);
        }
      }
      return item;
    });
    return parentKey;
  };

  // 项目目录详情
  getDirectoryInfo = uuid => {
    queryProjDirInfo({ uuid }).then(res => {
      if (res.statusCode === 200) {
        this.directoryInfo = res.data;
        this.setState({
          directoryInfo: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 展开
  onExpand = (Key, e) => {
    this.setState({
      expandedKeys: Key,
    });
  };

  // 选中
  onSelect = (selectedKeys, e) => {
    this.setState({
      selectedKeys,
    });
    this.props.onSelect({
      uuid: e.selected ? e.node.props.dataRef.uuid : '',
      name: e.selected ? e.node.props.dataRef.name : '',
    });
  };

  // 拖动
  onDrop = info => {
    const dropPos = info.node.props.pos.split('-');
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
    queryProjDirInfo({ uuid: info.node.props.dataRef.uuid }).then(res => {
      if (res.statusCode === 200) {
        const directoryInfo = res.data;
        const params = {};
        params.uuid = info.dragNode.props.dataRef.uuid;
        params.name = info.dragNode.props.dataRef.name;
        if (dropPosition === -1) {
          params.parentUuid = directoryInfo.parentUuid;
        } else {
          params.parentUuid = directoryInfo.uuid;
        }
        this.directoryAddSubmit(params);
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  /** ------------------新增/编辑/删除项目目录-------------------------------------------*/
  // 弹窗开关
  hideModalDirAdd = flag => {
    this.setState({
      dirAddVisible: !!flag,
    });
  };

  addTopDirectory = e => {
    e.stopPropagation();
    this.setState({ isAddType: true }, () => {
      this.hideModalDirAdd(true);
    });
  };

  // 新增的弹窗
  addDirectory = (item, e) => {
    e.stopPropagation();
    this.getDirectoryInfo(item.uuid);
    this.setState({ isAddType: true }, () => {
      this.hideModalDirAdd(true);
    });
  };

  // 编辑的弹窗
  editDirectory = (item, e) => {
    e.stopPropagation();
    this.getDirectoryInfo(item.uuid);
    this.setState({ isAddType: false }, () => {
      this.hideModalDirAdd(true);
    });
  };

  // 新增/编辑提交
  directoryAddSubmit = params => {
    const { project, projectUuid } = this.props;
    params.project = project;
    params.projectUuid = projectUuid;
    querySaveProjDir(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.getDirectoryList();
        this.hideModalDirAdd();
        this.setState({ directoryInfo: null });
      } else {
        message.error(res.message);
      }
    });
  };

  // 删除
  showDelDirectory = (item, e) => {
    e.stopPropagation();
    const _this = this;
    confirm({
      title: '确定删除该目录?',
      onOk() {
        _this.directoryDeleteSubmit(item);
      },
    });
  };

  directoryDeleteSubmit = item => {
    const params = {};
    item && (params.uuid = item.uuid);
    item &&
      queryDeleteProjDir(params).then(res => {
        if (res.statusCode === 200) {
          message.success(res.message);
          this.props.getDirectoryList();
          this.setState({ directoryInfo: null });
        } else {
          message.error(res.message);
        }
      });
  };
  /**-----------------------------------------------------------------------------*/

  titleItem = item => {
    return (
      <span className="treeTitle">
        {item.name}
        <span className="treeButton">
          <Icon
            type="edit"
            onClick={() => this.editDirectory(item)}
            style={{ paddingRight: '5px' }}
          />
          <Icon
            type="plus-circle"
            onClick={() => this.addDirectory(item)}
            style={{ paddingRight: '5px' }}
          />
          <Icon type="minus-circle" onClick={() => this.showDelDirectory(item)} />
        </span>
      </span>
    );
  };

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={this.titleItem(item)} key={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={this.titleItem(item)} key={item.uuid} dataRef={item} />;
    });
  };

  render() {
    const {
      list,
      isAddType,
      dirAddVisible,
      directoryInfo,
      selectedKeys,
      expandedKeys,
    } = this.state;
    return (
      <Card
        style={{ padding: '10px', height: '100%' }}
        bodyStyle={{ padding: '0', height: '100%' }}
      >
        <Row type="flex" justify="end">
          <Icon type="plus-circle" onClick={this.addTopDirectory} style={{ paddingRight: '5px' }} />
        </Row>
        <Tree
          showLine
          draggable
          onDrop={this.onDrop}
          onSelect={this.onSelect}
          selectedKeys={selectedKeys}
          onExpand={this.onExpand}
          expandedKeys={expandedKeys}
        >
          {this.renderTreeNodes(list || [])}
        </Tree>
        <ModalDirAdd
          visible={dirAddVisible}
          data={directoryInfo || {}}
          isAddType={isAddType}
          onOk={this.directoryAddSubmit}
          onCancel={() => this.hideModalDirAdd(false)}
        />
      </Card>
    );
  }
}

export default TreeDirectory;



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetailManage/TreeDirectory.js